import {
  Discount,
  PaymentType,
  Tax,
  TaxGroup,
  TaxPrimary,
} from '../../../models';
import { getRBPStringId } from '../../../page/main/main-page-states';
import http, { BASE_URL_3, OkPacket } from '../../http';

const paymentApi = {
  /**
   * 获取全局税率（菜品未设置税率组时使用该税率，即是JK后台中的餐厅基本信息中的税率）
   */
  async get_tax_primary(): Promise<TaxPrimary> {
    return await http.get(`${BASE_URL_3}/tax_primary/${getRBPStringId()}`);
  },

  /**
   * 获取税率组
   */
  async get_tax_group(rbpStringId?: string): Promise<TaxGroup[]> {
    const sid = (rbpStringId && rbpStringId.trim()) || getRBPStringId();
    return await http.get(`${BASE_URL_3}/tax_group/${sid}`);
  },

  /**
   * 编辑税率组
   */
  async patch_tax_group(id: number, taxGroup: TaxGroup): Promise<OkPacket> {
    return await http.patch(
      `${BASE_URL_3}/tax_group/${id}/${getRBPStringId()}`,
      taxGroup,
    );
  },

  /**
   * 新增税率
   * @param id
   * @param params
   * @returns
   */
  async post_tax(id: number, params: Tax): Promise<OkPacket> {
    return await http.post(
      `${BASE_URL_3}/tax_group/${id}/tax/${getRBPStringId()}`,
      params,
    );
  },
  /**
   * 编辑税率
   */
  async patch_tax(id: number, tax: Tax): Promise<OkPacket> {
    return await http.patch(`${BASE_URL_3}/tax/${id}/${getRBPStringId()}`, tax);
  },

  /**
   * 获取折扣
   */
  async get_discount(): Promise<Discount[]> {
    return await http.get(`${BASE_URL_3}/discount/${getRBPStringId()}`);
  },

  /**
   * 编辑折扣
   */
  async patch_discount(id: number, discount: Discount): Promise<OkPacket> {
    return await http.patch(
      `${BASE_URL_3}/discount/${id}/${getRBPStringId()}`,
      discount,
    );
  },

  /**
   * 获取付款方式
   */
  async get_payment_type(): Promise<PaymentType[]> {
    return await http.get(`${BASE_URL_3}/payment_type/${getRBPStringId()}`);
  },

  /**
   * 编辑付款方式
   */
  async patch_payment_type(
    id: number,
    discount: PaymentType,
  ): Promise<OkPacket> {
    return await http.patch(
      `${BASE_URL_3}/payment_type/${id}/${getRBPStringId()}`,
      discount,
    );
  },

  /**
   * 修改全局税率（菜品未设置税率组时使用该税率，即是JK后台中的餐厅基本信息中的税率）
   */
  async patch_tax_primary(params: TaxPrimary): Promise<TaxPrimary> {
    return await http.patch(`${BASE_URL_3}/tax_primary/${getRBPStringId()}`, params);
  },
  /**
   * 新增税率组
   */
  async post_tax_group(params: TaxGroup): Promise<OkPacket> {
    return await http.post(`${BASE_URL_3}/tax_group/${getRBPStringId()}`, params);
  },
  /**
   * 删除税率组及其下的税率
   */
  async delete_tax_group(ids: number[]): Promise<OkPacket> {
    return await http.delete(`${BASE_URL_3}/tax_group/${getRBPStringId()}`, { data: ids });
  },
  /**
   * 删除税率
   */
  async delete_tax(ids: number[]): Promise<OkPacket> {
    return await http.delete(`${BASE_URL_3}/tax/${getRBPStringId()}`, { data: ids });
  },
  /**
   * 新增折扣
   */
  async post_discount(params: Discount): Promise<OkPacket> {
    return await http.post(`${BASE_URL_3}/discount/${getRBPStringId()}`, params);
  },
  /**
   * 删除折扣
   */
  async delete_discount(ids: number[]): Promise<OkPacket> {
    return await http.delete(`${BASE_URL_3}/discount/${getRBPStringId()}`, { data: ids });
  },
  /**
   * 新增付款方式
   */
  async post_payment_type(params: PaymentType): Promise<OkPacket> {
    return await http.post(`${BASE_URL_3}/payment_type/${getRBPStringId()}`, params);
  },
  /**
   * 删除付款方式
   */
  async delete_payment_type(ids: number[]): Promise<OkPacket> {
    return await http.delete(`${BASE_URL_3}/payment_type/${getRBPStringId()}`, { data: ids });
  },
};

export default paymentApi;
